







import Vue from 'vue'
import { Component, Prop, Watch } from 'vue-property-decorator'
import BaseButton from '@/components/BaseButton.vue'
import Modal from '@/components/Modal.vue'
import { FieldInterpolation, getFieldFallback } from '@/utils/customFields'
import InputSingleLine from '@/components/Rain/Inputs/InputSingleLine.vue'
import BaseTooltip from '@/components/Rain/BaseTooltip.vue'

@Component<CustomFieldOpen>({
    components: { InputSingleLine, Modal, BaseButton, BaseTooltip }
})
export default class CustomFieldOpen extends Vue {
    @Prop()
    public target!: { input: HTMLInputElement }
    @Prop()
    public select!: Function
    @Prop()
    public scope!: any

    public open = false

    public async beforeMount() {
        this.$root.$on('customfield:hide', this.hide)
    }

    public beforeUnmount() {
        this.$root.$off('customfield:hide', this.hide)
    }

    public hide() {
        this.open = false
    }

    public click(e) {
        const { input } = this.target
        const { value, selectionStart, selectionEnd } = input
        const start = selectionStart ?? value.length
        const end = selectionEnd ?? value.length

        const fieldAndFallback = value.substring(start, end)

        const [, padding, field] = getFieldFallback(fieldAndFallback)

        const fieldInterpolation: FieldInterpolation = {
            start,
            end,
            field,
            padding,
            open: false,
            incomplete: true
        }

        this.open = true

        this.$root.$emit(
            'customfield:toggle',
            input,
            fieldInterpolation,
            this.scope,
            this.select
        )
    }
}
